import { useState } from 'react';
import { Link } from 'react-router-dom';
import { IconButton, Hidden, makeStyles } from '@material-ui/core';

import { labscoop_logo } from 'assets';
import LandingHeader from 'layouts/LandingHeader';
import MainHeader from 'layouts/MainHeader';
import Button2 from 'components/Button2';
import Icon from 'components/Icon';
import Text from 'components/Text';

import Navigation from './Navigation';
import SideNavigation from './SideNavigation';
import config from './config';

export const height = {
  desktop: 80,
  mobile: 68,
};

const useStyles = makeStyles((theme) => ({
  root: {
    '& ul': {
      paddingLeft: '40px',

      [theme.breakpoints.down('md')]: {
        paddingLeft: '0px',
        position: 'relative',
        left: '-40px',
        '& li': {
          marginRight: '8px',
        },
      },
    },
    [theme.breakpoints.down('xs')]: {
      height: height.mobile,
      '& ul': {
        display: 'none',
      },
    },
  },
  wrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    width: '144px',
    display: 'flex',
    alignItems: 'center',
    '& img': {
      width: 'inherit',
    },
    [theme.breakpoints.down('xs')]: {
      width: '130px',
      display: 'flex',
      alignItems: 'center',
      left: '24px',
    },
  },
  action: {
    display: 'flex',
    gap: theme.spacing(1),

    [theme.breakpoints.down('xs')]: {
      display: 'none',
    },
  },
  menuToggle: {
    [theme.breakpoints.down('xs')]: {
      marginLeft: 'auto',
    },
  },
  menuToggleButton: {
    marginRight: theme.spacing(-1),
  },
  content: {
    paddingTop: height.desktop,

    [theme.breakpoints.down('xs')]: {
      paddingTop: height.mobile,
    },
  },
}));

const GuestHeader = (props) => {
  const { children, landing, loading } = props;

  const [navigationActive, setNavigationActive] = useState(false);
  const classes = useStyles();

  const Header = landing ? LandingHeader : MainHeader;

  return (
    <>
      <Header className={classes.root} loading={loading} border={false}>
        <div className={classes.wrapper}>
          <Link to="/" className={`${classes.logo} no-decoration`}>
            <img src={labscoop_logo} alt="Labscoop" />
          </Link>

          <Navigation config={config} />

          <div className={classes.action}>
            <Button2
              variant="outlined"
              size="small"
              to={'/sign-in'}
              component={Link}
              height={32}
            >
              <Text
                variant="body3"
                textTransform="none"
                fontWeight={700}
                fontSize={13}
                lineHeight={1}
              >
                Sign in
              </Text>
            </Button2>

            <Button2
              variant="contained"
              size="small"
              to={'/sign-up'}
              component={Link}
              height={32}
            >
              <Text
                variant="body3"
                textTransform="none"
                fontWeight={500}
                fontSize={13}
                lineHeight={1}
              >
                Create an Account
              </Text>
            </Button2>
          </div>

          <Hidden smUp>
            <div className={classes.menuToggle}>
              <IconButton
                className={classes.menuToggleButton}
                color="primary"
                onClick={() => {
                  setNavigationActive((prev) => !prev);
                }}
              >
                <Icon.Burger fontSize={32} />
              </IconButton>
            </div>
          </Hidden>
        </div>
      </Header>

      <div className={classes.content}>{children}</div>

      <SideNavigation
        config={config}
        active={navigationActive}
        setActive={setNavigationActive}
      />
    </>
  );
};

export default GuestHeader;
